export const environment = {
  production: false,
  BASE_URL: "https://qaapi.sigmatconflux.com/api/",
  API_BASE_URL: "qaapi.sigmatconflux.com",
  PAYMENT_BASE_URL: "https://qaapi.sigmatconflux.com/api/",
  NAME: "qa environment",
  saveUrl: "",
  path: "",
  imageBaseUrl: "https://qaapi.sigmatconflux.com/uploads/",
  firebaseConfig: {
    apiKey: "AIzaSyAABWVHcf0TTRvkcDpmhw9pAgFFRlgUteY",
    authDomain: "clif-864a1.firebaseapp.com",
    projectId: "clif-864a1",
    storageBucket: "clif-864a1.firebasestorage.app",
    messagingSenderId: "275052466574",
    appId: "1:275052466574:web:aa2752b7634990818b54df",
  },
  mapboxToken:
    "pk.eyJ1IjoiZXhhbXBsZXVzZXIiLCJhIjoiY2t2eHBzYXN2dHgzbzJ2b3A0YmlzaDRkZCJ9.TG8An3-some-valid-token-string",
  geoserverWmsUrl: "",
  geoserverWfsUrl: "",
};
